import { render, staticRenderFns } from "./BtnetFooter.vue?vue&type=template&id=a91ad2f6&"
import script from "./BtnetFooter.vue?vue&type=script&lang=js&"
export * from "./BtnetFooter.vue?vue&type=script&lang=js&"
import style0 from "./BtnetFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports